import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import Alert from '../../../../../Alert/Alert';
import TempAccountLimit from '../../../../../Prompts/TempAccountLimit/TempAccountLimit';

import {
  TXTCLI_Confirm,
  TXTCLI_Just_so_you_know,
  TXTWCL_Confirm_my_identity,
  TXTWCL_Verify_my_account,
  TXTWCL_Your_registration_is_not_final_ELL
} from './TempAccountMessage.messages.json';
import { alert, unverified } from './TempAccountMessage.scss';

const TempAccountMessage: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const verifyDoc: boolean = useFeature(FeatureFlag.VerifyDoc);
  const hardVerificationV2 = useFeature(FeatureFlag.HardVerificationV2);
  const hardVerificationV3 = useFeature(FeatureFlag.HardVerificationV3);

  const getButtonLabel = () => {
    if (hardVerificationV2) {
      return TXTWCL_Confirm_my_identity;
    } else if (hardVerificationV3) {
      return TXTCLI_Confirm;
    } else {
      return TXTWCL_Verify_my_account;
    }
  };

  const openPrompt = (e: React.MouseEvent) => {
    e.preventDefault();
    isEmbedded && verifyDoc ? window.starsweb?.app?.execute('docverify') : setShowPrompt(true);
  };

  return (
    <>
      <Alert variant="warning" className={alert}>
        <Translation {...TXTCLI_Just_so_you_know} />
        <div className={unverified}>
          <Translation {...TXTWCL_Your_registration_is_not_final_ELL} />{' '}
        </div>
        <StarsLink onClick={openPrompt}>
          <Translation {...getButtonLabel()} />
        </StarsLink>
      </Alert>
      {showPrompt && <TempAccountLimit onClose={() => setShowPrompt(false)} />}
    </>
  );
};
export default TempAccountMessage;
